<meta
  name="viewport"
  content="width=device-width, initial-scale=1.0, user-scalable=no"
/>
<router-outlet></router-outlet>
